<template>
  <div id="PublicPage">this is public page</div>
</template>

<script>
'use strict'
import DataSource from '../../data/datasource'

export default {
  name: 'PublicPage',
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  components: {},
}
</script>

<style scoped></style>
